import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadPerListStatus: 'idle',
    loadPerListError: undefined as any,
    loadPerListLastArgs: undefined as any,
    loadPerStatus: 'idle',
    loadPerError: undefined as any,
    savePerStatus: 'idle',
    savePerError: undefined as any,
    deletePerStatus: 'idle',
    deletePerError: undefined as any,

    perList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadPerList = createAsyncThunk('perSlice/loadPerList', async ({ globalFilters, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().perSlice.loadPerListLastArgs
    if (_.isEqual(lastArgs, { globalFilters }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/per/?action=gte&MIN_OBJNR=${globalFilters.objectFilter || '00000'}&MAX_OBJNR=${globalFilters.objectFilter || '99999'}`, globalFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }
    {
        const [url, params] = prepParams(`/api/ixweb/adm/`, globalFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }
    {
        const [url, params] = prepParams(`/api/ixweb/adm/`, globalFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [perRes, adm1Res, adm2Res] = await Promise.all(promises)
    const per = getRespData(perRes, rejectWithValue)
    const adm1 = getRespData(adm1Res, rejectWithValue)
    const adm2 = getRespData(adm2Res, rejectWithValue)

    return {
        data: per.map((x: any) => ({
            ...x,
            adm1: { ...adm1.find((y: any) => y.KNO === x.ADAM) },
            adm2: { ...adm2.find((y: any) => y.KNO === x.LOCADAM) },
        })),
        args: { globalFilters }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadPerListStatus } = getState().perSlice
        return loadPerListStatus !== 'pending'
    }
})

export const loadPer = createAsyncThunk('perSlice/loadPer', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/per/?action=eql&HDR_ID=${id}`,
    ))

    const [perRes] = await Promise.all(promises)
    const per = getRespData(perRes, rejectWithValue, true)
    promises = []
    promises.push(client.get(
        `/api/ixweb/adm/?action=eql&kno=${per.ADAM}`,
    ))
    promises.push(client.get(
        `/api/ixweb/adm/?action=eql&kno=${per.LOCADAM}`,
    ))

    const [adm1Res, adm2Res] = await Promise.all(promises)
    const adm1 = getRespData(adm1Res, null, true)
    const adm2 = getRespData(adm2Res, null, true)

    return {
        data: {
            ...per,
            adm1: { ...adm1 },
            adm2: { ...adm2 },
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadPerStatus } = getState().perSlice
        return loadPerStatus !== 'pending'
    }
})

export const savePer = createAsyncThunk('perSlice/savePer', async ({ per }: any, { rejectWithValue }: any) => {
    let promises = []
    if (per?.adm1?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/adm/${ per?.adm1?.HDR_ID }/`,
            prepareData(per.adm1),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/adm/`,
            prepareData(per.adm1),
        ))
    }
    if (per?.adm2?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/adm/${ per?.adm2?.HDR_ID }/`,
            prepareData(per.adm2),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/adm/`,
            prepareData(per.adm2),
        ))
    }

    const [adm1ResRes, adm2ResRes] = await Promise.all(promises)
    const adm1Res = getRespData(adm1ResRes, rejectWithValue, true)
    const adm2Res = getRespData(adm2ResRes, rejectWithValue, true)
    promises = []
    if (per?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/per/${ per?.HDR_ID }/`,
            prepareData({ ...per, ADAM: adm1Res.KNO, LOCADAM:adm2Res.KNO }),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/per/`,
            prepareData({ ...per, ADAM: adm1Res.KNO, LOCADAM:adm2Res.KNO }),
        ))
    }

    const [perResRes] = await Promise.all(promises)
    const perRes = getRespData(perResRes, null, true)

    return {
        data: {
            adm1: { ...adm1Res },
            adm2: { ...adm2Res },
            ...perRes,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { savePerStatus } = getState().perSlice
        return savePerStatus !== 'pending'
    }
})

export const deletePer = createAsyncThunk('perSlice/deletePer', async ({ per }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/per/${per.HDR_ID}/`,
    ))
    promises.push(client.delete(
        `/api/ixweb/adm/${per.adm1.HDR_ID}/`,
    ))
    promises.push(client.delete(
        `/api/ixweb/adm/${per.adm2.HDR_ID}/`,
    ))

    const [value1Res, value2Res, value3Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)
    const value2 = getRespData(value2Res, rejectWithValue)
    const value3 = getRespData(value3Res, rejectWithValue)

    return {
        data: per.HDR_ID,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deletePerStatus } = getState().perSlice
        return deletePerStatus !== 'pending'
    }
})

const PerSlice = createSlice({
    name: 'perSlice',
    initialState,
    reducers: {
        resetloadPerListError: (state) => {
            state.loadPerListError = undefined
        },
        resetloadPer: (state) => {
            state.formItem = undefined
            state.loadPerError = undefined
        },
        resetloadPerError: (state) => {
            state.loadPerError = undefined
        },
        resetsavePer: (state) => {
            state.formItem = undefined
            state.savePerError = undefined
        },
        resetsavePerError: (state) => {
            state.savePerError = undefined
        },
        resetdeletePerError: (state) => {
            state.deletePerError = undefined
        },
        removeFromPerListById: (state, action) => {
            state.perList = state.perList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromPerListByIds: (state, action) => {
            state.perList = state.perList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.perList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadPerListStatus = 'preloaded'
            state.loadPerListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.perList = []
            state.loadPerListStatus = 'idle'
            state.loadPerListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadPerList.pending, (state) => {
            state.loadPerListStatus = 'pending'
            state.loadPerListError = undefined
        })
        builder.addCase(loadPerList.fulfilled, (state, action) => {
            state.loadPerListStatus = 'idle'

            if (!action.payload) { return }

            state.loadPerListLastArgs = action.payload.args

            {
                state.perList = action.payload.data

            }
        })
        builder.addCase(loadPerList.rejected, (state, action) => {
            state.loadPerListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadPerListError = action.error.message
            } else {
                state.loadPerListError = action.payload
            }
        })

        builder.addCase(loadPer.pending, (state) => {
            state.loadPerStatus = 'pending'
            state.loadPerError = undefined
        })
        builder.addCase(loadPer.fulfilled, (state, action) => {
            state.loadPerStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.perList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.perList.push(newItem) }
                else { state.perList[i] = { ...state.perList[i], ...newItem } }
            }
        })
        builder.addCase(loadPer.rejected, (state, action) => {
            state.loadPerStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadPerError = action.error.message
            } else {
                state.loadPerError = action.payload
            }
        })

        builder.addCase(savePer.pending, (state) => {
            state.savePerStatus = 'pending'
            state.savePerError = undefined
        })
        builder.addCase(savePer.fulfilled, (state, action) => {
            state.savePerStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.perList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.perList.push(newItem) }
                else { state.perList[i] = { ...state.perList[i], ...newItem } }
            }
        })
        builder.addCase(savePer.rejected, (state, action) => {
            state.savePerStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.savePerError = action.error.message
            } else {
                state.savePerError = action.payload
            }
        })

        builder.addCase(deletePer.pending, (state) => {
            state.deletePerStatus = 'pending'
            state.deletePerError = undefined
        })
        builder.addCase(deletePer.fulfilled, (state, action) => {
            state.deletePerStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.perList = state.perList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.perList = state.perList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deletePer.rejected, (state, action) => {
            state.deletePerStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deletePerError = action.error.message
            } else {
                state.deletePerError = action.payload
            }
        })

    }
})

export const {
    resetloadPerListError,
    resetloadPer,
    resetloadPerError,
    resetsavePer,
    resetsavePerError,
    resetdeletePerError,
    removeFromPerListById,
    removeFromPerListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = PerSlice.actions
export default PerSlice.reducer
